import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { auth } from '../firebase'
import {
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
  onAuthStateChanged,
} from 'firebase/auth'
import toast from 'react-hot-toast'
import Header from '../components/Header'
import Footer from '../components/Footer'
import {
  customer_request_email,
  messageEmailClear,
} from '../store/reducers/authReducer'
import { useDispatch, useSelector } from 'react-redux'
// import { send_email_link, verify_email_token } from '../store/reducers/authReducer'
// import { useDispatch } from 'react-redux'

const RegisterCode = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [codeSent, setCodeSent] = useState(false)
  const [customerId, setCustomerId] = useState(null)

  const { successMessageEmail, errorMessageEmail, customerIdReturn } =
    useSelector((state) => state.auth)

  const location = useLocation()
  const fromPage = location.state?.from || localStorage.getItem('fromPage')

  useEffect(() => {
    async function handleSignIn() {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let storedEmail = window.localStorage.getItem('emailForRegistration')

        if (!storedEmail && window.location.hostname === 'localhost') {
          // Ask user to confirm email if missing (common in localhost env)
          storedEmail = window.prompt(
            'Please confirm your email for verification:'
          )
          if (!storedEmail) {
            toast.error('Email is required to complete sign-in.')
            // setLoading(false)
            return
          }
        }

        try {
          await signInWithEmailLink(auth, storedEmail, window.location.href)
          window.localStorage.removeItem('emailForRegistration')
          window.localStorage.setItem('verifiedEmail', storedEmail)

          // Wait for Firebase auth state to confirm sign-in
          const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
              unsubscribe()
              if (fromPage === 'forgot') {
                navigate('/forgotPassword')
              } else {
                navigate('/register', { state: { verifiedEmail: storedEmail } })
              }
            }
          })
        } catch (error) {
          toast.error(`Verification failed: ${error.message}`)
          // setLoading(false)
        }
      } else {
        // Not a sign-in link, normal page load
        // setLoading(false)
      }
    }

    handleSignIn()
  }, [navigate, fromPage])

  // Handle sending the sign-in link email
  const handleSubmit = async (e) => {
    e.preventDefault()
    localStorage.setItem('customerID', customerIdReturn)

    const lastSent = localStorage.getItem('emailVerificationAttempt')
    if (lastSent) {
      const timeSinceLast = Date.now() - lastSent
      const cooldown = 2 * 60 * 1000 // 15 minutes

      if (timeSinceLast < cooldown) {
        toast.error(
          `Please wait ${Math.ceil(
            (cooldown - timeSinceLast) / 60000
          )} minutes before requesting another link`
        )
        return
      }
    }

    try {
      const actionCodeSettings = {
        url:
          process.env.NODE_ENV === 'development'
            ? 'http://localhost:3000/register'
            : 'https://snusconicotine.com/register',
        handleCodeInApp: true,
      }

      await sendSignInLinkToEmail(auth, email, actionCodeSettings)
      window.localStorage.setItem('emailForRegistration', email)
      localStorage.setItem('emailVerificationAttempt', Date.now())
      setCodeSent(true)
      toast.success('Verification link sent to your email!')
    } catch (error) {
      if (error.code === 'auth/quota-exceeded') {
        toast.error('Daily verification limit reached. Try again tomorrow.')
      } else {
        toast.error(`Error sending link: ${error.message}`)
      }
    }

    if (!email) {
      toast.error('Please enter an email address')
      return
    }

    dispatch(customer_request_email({ email }))
  }

  useEffect(() => {
    if (successMessageEmail) {
      toast.success(successMessageEmail)
      localStorage.setItem('customerID', customerIdReturn)
      dispatch(messageEmailClear())
    }
    if (errorMessageEmail) {
      toast.error(errorMessageEmail)

      dispatch(messageEmailClear())
    }
  }, [successMessageEmail, errorMessageEmail])

  return (
    <div>
      <Header />
      <div className="bg-slate-100 mt-4">
        <div className="w-full justify-center items-center p-10 sm:p-4">
          <div className="grid grid-cols-1 w-[30%] sm:w-full mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-center w-full text-xl text-slate-600 font-bold">
                Verify Your Email
              </h2>

              {!codeSent ? (
                <form onSubmit={handleSubmit} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      required
                    />
                  </div>
                  <button className="px-8 w-full py-2 mt-4 bg-primary shadow-lg hover:bg-[#256398] text-white rounded-md">
                    Send Verification Link
                  </button>
                </form>
              ) : (
                <div className="text-center text-slate-600">
                  <p>Check your email for the verification link.</p>
                  <p className="mt-2">
                    If you didn't receive it, check your spam folder or try
                    resending.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default RegisterCode
